<template>

    <v-alert v-if="hasLimit" type="info">
        <span v-if="!user.is_sub_account && !user.features.ltd">{{ $t('labels.limit') }}: {{ value | numeral }} {{ model }}. <router-link :to="{ name: 'account.billing' }">{{ $t('labels.upgrade_for_more') }}</router-link>.</span>
        <span v-else>{{ $t('labels.limit') }}: {{ value | numeral }} {{ model }}.</span>
    </v-alert>

    <v-alert v-else-if="isDisabled" type="info">
        <span v-if="!user.is_sub_account && !user.features.ltd"><router-link :to="{ name: 'account.billing' }">{{ $t('labels.upgrade_to_use') }}</router-link>.</span>
        <span v-else>{{ $t('labels.upgrade_to_use') }}.</span>
    </v-alert>

</template>

<script>

export default {

    props: {
        feature: {
            type: String,
            default: null,
        },
    },

    computed: {

        value() {
            return this.project.features[this.feature];
        },

        isDisabled() {
            return this.value === false;
        },

        hasLimit() {
            return Number.isFinite(this.value) && this.value >= 0;
        },

        model() {
            let model = null;
            switch (this.feature) {
            case 'asks':
                model = this.$t('labels.monthly_requests');
                break;
            case 'customers':
                model = this.value === 1 ? this.$t('labels.customer') : this.$t('labels.customers');
                break;
            case 'forms':
                model = this.value === 1 ? this.$t('labels.review_page') : this.$t('labels.review_pages');
                break;
            case 'links':
                model = this.value === 1 ? this.$t('labels.link') : this.$t('labels.links');
                break;
            case 'locations':
                model = this.value === 1 ? this.$t('labels.location') : this.$t('labels.locations');
                break;
            case 'members':
                model = this.value === 1 ? this.$t('labels.member') : this.$t('labels.members');
                break;
            case 'projects':
                model = this.value === 1 ? this.$t('labels.project') : this.$t('labels.projects');
                break;
            case 'sources':
                model = this.value === 1 ? this.$t('labels.source') : this.$t('labels.sources');
                break;
            case 'spaces':
                model = this.value === 1 ? this.$t('labels.space') : this.$t('labels.spaces');
                break;
            case 'tags':
                model = this.value === 1 ? this.$t('labels.tag') : this.$t('labels.tags');
                break;
            case 'validations':
                model = this.value === 1 ? this.$t('labels.validation') : this.$t('labels.validations');
                break;
            case 'widgets':
                model = this.value === 1 ? this.$t('labels.widget') : this.$t('labels.widgets');
                break;
            }
            return model !== null ? model.toLowerCase() : null;
        },

    },

}

</script>
